import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getSireSnippetsSlice = createSlice({
    name: 'SireSnippets',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchSireSnippets.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchSireSnippets.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchSireSnippets.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setSireSnippets, setStatus } = getSireSnippetsSlice.actions;
export default getSireSnippetsSlice.reducer;

export const fetchSireSnippets = createAsyncThunk('/SireSnippets/fetch', async ({StartDate,
    EndDate,RaceCourseSearch,HorseKindSearch,TrackLengthSearch,RaceTypeSearch,RaceKindSearch,RaceGroundSearch,RaceNationalitySearch,currentPage}) => {
    const res = await axios.get(`${getBaseUrl()}/SireSnippets?startTimeTo=${StartDate}&startTimeFrom=${EndDate}&RaceCourse=${RaceCourseSearch}&HorseKindinRace=${HorseKindSearch}&TrackLength=${TrackLengthSearch}&RaceType=${RaceTypeSearch}&RaceKind=${RaceKindSearch}&NationalityID=${RaceNationalitySearch}&Ground=${RaceGroundSearch}&page=${currentPage}&size=10`);
    const SireSnippetsData = res.data;
    return SireSnippetsData;
})